// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"3c69a7b2","453":"99a84413"}[chunkId] + ".chunk.js";
};